var App = App || {};

App.VcFinancialEducationBlogPostRelated = (function ($) {
    "use strict";

    function init() {
        var $carouselSection = $("section.vc.vc-financial-education.vc-blog-post-related");

        if ($carouselSection.length) {
            $.each($carouselSection, function () {
                var $this = $(this),
                    $carousel = $this.find(".slides"),
                    $carouselControls = $this.find(".controls");

                if ($carousel.length) {
                    $carousel.slick({
                        appendArrows: $carouselControls,
                        arrows: true,
                        centerPadding: "2rem",
                        centerMode: true,
                        autoplay: false,
                        mobileFirst: true,
                        nextArrow: "<button class=\"slick-next slick-arrow\" aria-label=\"Next promotion\" type=\"button\"><span class=\"fas fa-fw fa-arrow-right\"></span></button>",
                        prevArrow: "<button class=\"slick-prev slick-arrow\" aria-label=\"Previous promotion\" type=\"button\"><span class=\"fas fa-fw fa-arrow-left\"></span></button>",
                        responsive: [
                            {
                                breakpoint: 767,
                                settings: {
                                    centerPadding: "0"
                                }
                            },
                            {
                                breakpoint: 1199,
                                settings: {
                                    centerMode: false,
                                    slidesToShow: 2
                                }
                            }
                        ],
                        slidesToScroll: 1,
                        slidesToShow: 1
                    });
                }
            });
        }
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.VcFinancialEducationBlogPostRelated.init();
});